<template>
  <div class="col-12">
    <div
      class="tile d-flex flex-row align-items-center mt-0 p-2 py-3 rounded"
      v-if="isAudioFile"
    >
      <div
        v-if="loadingplayer == 100"
        class="col-2 col-sm-2 col-md-3 col-lg-1 col-xl-1 text-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          height="50px"
          v-if="playing"
          viewBox="0 0 512 512"
          @click="fnPause"
        >
          <path
            fill="#fff"
            d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM224 191.1v128C224 337.7 209.7 352 192 352S160 337.7 160 320V191.1C160 174.3 174.3 160 191.1 160S224 174.3 224 191.1zM352 191.1v128C352 337.7 337.7 352 320 352S288 337.7 288 320V191.1C288 174.3 302.3 160 319.1 160S352 174.3 352 191.1z"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          v-else
          viewBox="0 0 512 512"
          width="50px"
          height="50px"
          @click="fnPlay"
        >
          <path
            fill="#fff"
            d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM176 168V344C176 352.7 180.7 360.7 188.3 364.9C195.8 369.2 205.1 369 212.5 364.5L356.5 276.5C363.6 272.1 368 264.4 368 256C368 247.6 363.6 239.9 356.5 235.5L212.5 147.5C205.1 142.1 195.8 142.8 188.3 147.1C180.7 151.3 176 159.3 176 168V168z"
          />
        </svg>
      </div>
      <div v-else>{{ loadingplayer }} %</div>
      <div class="col-6 ml-2">
        <wavesurfer :src="url" :options="options" ref="uplayer"></wavesurfer>
      </div>
      <div
        class="col-2 d-text d-sm-none d-xs-none d-md-none d-none d-lg-block d-xl-block"
      ></div>
      <div
        class="s-text d-lg-flex d-xl-flex d-none col-3 col-sm-3 col-md-3 col-lg-1 col-xl-1 d-sm-none d-xs-none"
      ></div>
      <div class="col-2 text-right d-flex justify-content-end">
        <a :href="url" class="d-flex justify-content-center align-items-center">
          <img
            class="d-img mx-1"
            src="../assets/done.png"
            alt=""
            height="30px"
            width="30px"
        /></a>
      </div>
    </div>
    <div
      class="tile d-flex flex-row align-items-center justify-content-between mt-0 p-2 py-3 rounded"
      v-else
    >
      {{ name }}
      <div class="col-2 text-right d-flex justify-content-end">
        <a :href="url" class="d-flex justify-content-center align-items-center">
          <img
            class="d-img mx-1"
            src="../assets/done.png"
            alt=""
            height="30px"
            width="30px"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import WaveSurferVue from "wavesurfer.js-vue";
import Cursor from "wavesurfer.js/dist/plugin/wavesurfer.cursor";
export default {
  components: {
    WaveSurferVue,
  },
  data() {
    return {
      playing: 0,
      loadingplayer: 0,
      isAudioFile:
        this.$props.url.split(".")[this.$props.url.split(".").length - 1] ===
        "zip"
          ? 0
          : 1,
      options: {
        mediaControls: true,
        normalize: true,
        barWidth: 3,
        barGap: 1,
        plugins: [Cursor.create()],
        barHeight: 1,
        height: 50,
        cursorColor: "#2BFED1",
        progressColor: "#2BFED1",
      },
    };
  },
  props: {
    name: String,
    url: String,
  },
  mounted() {
    this.player.on("ready", () => {
      // player is ready
    });
    this.player.on("loading", (val, evt) => {
      // player is loading
      this.loadingplayer = val;
    });
  },
  computed: {
    player() {
      return this.$refs.uplayer.waveSurfer;
    },
  },
  methods: {
    fnPlay() {
      this.playing = 1;
      this.player.play();
    },
    fnPause() {
      this.playing = 0;
      this.player.pause();
    },
  },
};
</script>

<style scoped>
.d-img:hover {
  content: url("../assets/download.png");
}
</style>
